import { UIHeading2 } from '@cian/ui-kit';
import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

import { EDeviceType } from '../../types/device';

import * as styles from './ResultsEmpty.css';

export interface IResultsEmptyStoreProps {
  deviceType: EDeviceType;
  onClick(): void;
}

export const ResultsEmptyForAuthorization: React.FC<IResultsEmptyStoreProps> = props => {
  const { deviceType, onClick } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        <div className={styles['content']}>
          <div className={styles['empty-background']} />
          <div className={styles['title']}>
            <UIHeading2>Войдите, чтобы увидеть объявления</UIHeading2>
          </div>
          <Button size={deviceType === EDeviceType.Desktop ? 'XS' : 'M'} theme="fill_primary" onClick={onClick}>
            Вход или регистрация
          </Button>
        </div>
      </div>
    </div>
  );
};
